/* eslint-disable */
import api from 'apiModule/rest';

// query serialized item (devices) in a warehouse
const deviceWarehouseList = body => {
  const endpoint = `device/warehouses/${body.warehouseId}?skuId=${body.skuId}&page_size=${body.page_size}&page_no=${body.page_no}`;
  return api.device.deviceWarehouseList(endpoint);
};

export default {
  deviceWarehouseList,
};
